const bodyScrollLock = require('body-scroll-lock');
// const disableBodyScroll = bodyScrollLock.disableBodyScroll;
// const enableBodyScroll = bodyScrollLock.enableBodyScroll;


"use strict";

if (!("ui" in window)) {
  window.ui = {};
}



// ********************
// DOM Variables
var uiRoot = document.body;
var uiMasthead = document.querySelector(".ui-masthead");
var uiHeader = document.querySelector(".ui-header");
var uiHeaderNavToggle = document.querySelector(".ui-header__nav-toggle");
var uiTray = document.querySelector(".ui-tray");
var uiTrayClose = document.querySelector(".ui-tray__close");
var uiTrayTabs = document.querySelectorAll(".ui-tray__tab");
var uiTrayMain = document.querySelector(".ui-tray__main");
var uiTrayPanels = document.querySelectorAll(".ui-tray__panel");
var uiNav = document.querySelector(".ui-nav");
var uiSubheadMenuToggle = document.querySelector(".ui-subhead__menu-toggle");
var uiMenu = document.querySelector(".ui-menu");
var uiOverlay = document.querySelector(".ui-overlay");
var uiPlaceholder = document.querySelector(".ui-placeholder");
var uiSearch = document.querySelector(".ui-search");
var uiSearchToggle = document.querySelector(".ui-header__search-toggle");
var uiSearchBack = document.querySelector(".ui-search__back");
var uiSearchClear = document.querySelector(".ui-search__clear");
var uiSearchInput = document.querySelector(".ui-search__input");
var uiSearchForm = document.querySelector(".ui-search__form");
var uiSearchResults = document.querySelector(".ui-search__results");
var uiSearchSubmit = document.querySelector(".ui-search__submit");
var uiAnswerAsUserHiddenInput = document.querySelector("#answer_as_user");

// ********************
// Media Queries
var mediaMedium = window.matchMedia("(min-width: 768px)");
var mediaLarge = window.matchMedia("(min-width: 1024px)");
var mediaXlarge = window.matchMedia("(min-width: 1280px)");

// ********************
// Fastclick for mobile browsers
uiRoot.addEventListener("touchstart", function () {}, { passive: true });

// ********************
// Keyboard event helpers

// a11yclick
function a11yClick(event) {
  if (event.type === "click") {
    return true;
  } else if (event.type === "keydown") {
    if (event.key === " " || event.key === "Enter") {
      return true;
    }
  }
  return false;
}

// escClick
function escKey(event) {
  return event.key == "Escape";
}

// Focus trap: constrain Tab/Shift+Tab within a container
var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

function trapFocus(evt, container) {
  if (evt.key !== "Tab") return;

  var focusable = Array.from(container.querySelectorAll(FOCUSABLE)).filter(function (el) {
    return el.offsetParent !== null; // visible only
  });
  if (focusable.length === 0) return;

  var first = focusable[0];
  var last = focusable[focusable.length - 1];

  if (evt.shiftKey && document.activeElement === first) {
    evt.preventDefault();
    last.focus();
  } else if (!evt.shiftKey && document.activeElement === last) {
    evt.preventDefault();
    first.focus();
  }
}

// Track the element that triggered a panel open, for focus restoration
var focusStack = [];

function saveFocus() {
  focusStack.push(document.activeElement);
}

function restoreFocus() {
  var el = focusStack.pop();
  if (el && el.focus && el.offsetParent !== null) {
    el.focus();
  }
}

function discardFocus() {
  focusStack.pop();
}

// ********************
// Resizing

var resizeTimer = null;

function doResize() {
  if (resizeTimer != null) {
    window.cancelAnimationFrame(window.ui.resizeTimer);
  }

  resizeTimer = window.requestAnimationFrame(function () {
    if (uiMasthead) {
      // Size the placeholder to the size of the header
      var mastheadHeight = uiMasthead.offsetHeight;
      uiPlaceholder.style.height = mastheadHeight + "px";
    }

    // Position the menu under the masthead
    if (uiMenu != null) {
      uiMenu.style.top = mastheadHeight + "px";
    }

    // Tray resizing
    if (uiTray) {
      if (mediaLarge.matches) {
        uiTray.style.maxHeight =
          window.innerHeight - uiHeader.offsetTop + "px";
      } else {
        uiTray.style.maxHeight = null;
      }
    }

    // Search resizing
    if (uiSearch) {
      if (mediaMedium.matches) {
        uiSearch.style.maxHeight =
          window.innerHeight - uiHeader.offsetTop - 16 + "px";
      } else {
        uiSearch.style.maxHeight = null;
      }
    }

    // Hide menus and such on screen size changes
    if (mediaLarge.matches) {
      closeNav(true);
      closeMenu(true);
    }

    // Remove the unsized flag (used to prevent content jitter)
    uiRoot.classList.remove("ui--unsized");

    // Clear the timer since we're done
    resizeTimer = null;
  });
}

doResize();

window.ui.resize = doResize;
window.addEventListener("resize", doResize, { passive: true });
window.addEventListener("load", doResize, { passive: true });
window.addEventListener("orientationchange", doResize, { passive: true });

// ********************
// Overlay - clicking the overlay always closes everything easy

function doOverlayClick(evt) {
  if (a11yClick(evt)) {
    closeNav();
    closeMenu();
    closeSearch();
    closeTray();
    evt.preventDefault();
  }
}

if (uiOverlay) {
  uiOverlay.addEventListener("click", doOverlayClick);
}

// ********************
// Nav

function isNavOpen() {
  return uiRoot.classList.contains("ui--nav-open");
}

function doNavKeydown(evt) {
  if (escKey(evt)) {
    closeNav();
    evt.preventDefault();
  } else if (uiNav) {
    trapFocus(evt, uiNav);
  }
}

function openNav() {
  if (isNavOpen()) {
    return;
  }

  closeMenu(true);
  closeSearch(true);
  closeTray(true);
  saveFocus();
  uiRoot.classList.add("ui--nav-open");
  uiHeaderNavToggle.setAttribute("aria-expanded", "true");
  uiHeaderNavToggle.setAttribute("aria-label", "Close navigation");
  document.addEventListener("keydown", doNavKeydown);

  if (uiNav) {
    requestAnimationFrame(function () {
      var firstLink = uiNav.querySelector(FOCUSABLE);
      if (firstLink) firstLink.focus();
    });
  }
}

function closeNav(skipRestore) {
  if (!isNavOpen()) {
    return;
  }

  uiRoot.classList.remove("ui--nav-open");
  uiHeaderNavToggle.setAttribute("aria-expanded", "false");
  uiHeaderNavToggle.setAttribute("aria-label", "Open navigation");
  document.removeEventListener("keydown", doNavKeydown);
  if (skipRestore) { discardFocus(); } else { restoreFocus(); }
}

function toggleNav() {
  if (isNavOpen()) {
    closeNav();
  } else {
    openNav();
  }
}

function doNavToggleClick(evt) {
  if (a11yClick(evt)) {
    toggleNav();
    evt.preventDefault();
  }
}


window.ui.openNav = openNav;
window.ui.closeNav = closeNav;
window.ui.toggleNav = toggleNav;

if (uiHeaderNavToggle) {
  uiHeaderNavToggle.addEventListener("click", doNavToggleClick);
  uiHeaderNavToggle.addEventListener("keydown", doNavToggleClick);
}

// ********************
// Menu

function isMenuOpen() {
  return uiRoot.classList.contains("ui--menu-open");
}

function doMenuKeydown(evt) {
  if (escKey(evt)) {
    closeMenu();
    evt.preventDefault();
  } else if (uiMenu) {
    trapFocus(evt, uiMenu);
  }
}

function openMenu() {
  if (isMenuOpen()) {
    return;
  }

  closeNav(true);
  closeSearch(true);
  closeTray(true);
  saveFocus();
  uiRoot.classList.add("ui--menu-open");
  if (uiSubheadMenuToggle) uiSubheadMenuToggle.setAttribute("aria-expanded", "true");
  document.addEventListener("keydown", doMenuKeydown);

  if (uiMenu) {
    requestAnimationFrame(function () {
      var firstItem = uiMenu.querySelector(FOCUSABLE);
      if (firstItem) firstItem.focus();
    });
  }
}

function closeMenu(skipRestore) {
  if (!isMenuOpen()) {
    return;
  }

  uiRoot.classList.remove("ui--menu-open");
  if (uiSubheadMenuToggle) uiSubheadMenuToggle.setAttribute("aria-expanded", "false");
  document.removeEventListener("keydown", doMenuKeydown);
  if (skipRestore) { discardFocus(); } else { restoreFocus(); }
}

function toggleMenu() {
  if (isMenuOpen()) {
    closeMenu();
  } else {
    openMenu();
  }
}

function doMenuToggleClick(evt) {
  if (a11yClick(evt)) {
    toggleMenu();
    evt.preventDefault();
  }
}


window.ui.openMenu = openMenu;
window.ui.closeMenu = closeMenu;
window.ui.toggleMenu = toggleMenu;

if (uiSubheadMenuToggle) {
  uiSubheadMenuToggle.addEventListener("click", doMenuToggleClick);
  uiSubheadMenuToggle.addEventListener("keydown", doMenuToggleClick);
}

// ********************
// Tray

function isTrayOpen() {
  return uiRoot.classList.contains("ui--tray-open");
}

function isTrayStuck() {
  return uiRoot.classList.contains("ui--tray-sticky") && mediaXlarge.matches;
}

var activeTrayPanel = null;

function doTrayKeydown(evt) {
  if (escKey(evt)) {
    closeTray();
    evt.preventDefault();
  } else if (uiTray) {
    trapFocus(evt, uiTray);
  }
}

function openTray(name) {
  if (name === null) {
    return closeTray();
  }

  closeNav(true);
  closeMenu(true);
  closeSearch(true);

  activateTray(name);

  if (!isTrayStuck()) {
    saveFocus();
    uiRoot.classList.add("ui--tray-open");
    document.addEventListener("keydown", doTrayKeydown);

    if (!mediaLarge.matches) {
      bodyScrollLock.disableBodyScroll(activeTrayPanel);
    }

    // Move focus into tray
    requestAnimationFrame(function () {
      if (uiTrayClose) uiTrayClose.focus();
    });
  }

  // Set aria-expanded after tray is open
  uiTrayTabs.forEach(function (tab) {
    tab.setAttribute("aria-expanded", tab.dataset.tray === name ? "true" : "false");
  });
}

function activateTray(name) {
  var trayVisible = isTrayOpen() || isTrayStuck();
  uiTrayTabs.forEach(function (tab) {
    if (tab.dataset.tray === name) {
      tab.classList.add("ui-tray__tab--active");
      tab.setAttribute("aria-expanded", trayVisible ? "true" : "false");
    } else {
      tab.classList.remove("ui-tray__tab--active");
      tab.setAttribute("aria-expanded", "false");
    }
  });

  uiTrayPanels.forEach(function (panel) {
    if (panel.dataset.tray === name) {
      panel.classList.add("ui-tray__panel--active");
      activeTrayPanel = panel;
    } else {
      panel.classList.remove("ui-tray__panel--active");
    }
  });
}

function loadTrayPanel(panel) {
  var url = panel.dataset.url;
  if (!url) {
    return;
  }

  panel.classList.add("ui-tray__panel--loading");

  var xhr = new XMLHttpRequest();
  xhr.open("GET", url);
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  xhr.onload = function () {
    if (xhr.status === 200) {
      // Create replacement DIV
      var newPanel = document.createElement("div");
      newPanel.innerHTML = xhr.responseText;
      newPanel = newPanel.children[0];
      newPanel.removeAttribute("data-url");

      // Keeps active if currently active
      if (panel.classList.contains("ui-tray__panel--active")) {
        newPanel.classList.add("ui-tray__panel--active");
      }

      // Hide any loading or error states
      newPanel.classList.remove("ui-tray__panel--loading");
      newPanel.classList.remove("ui-tray__panel--error");

      // put into the dom
      uiTrayMain.replaceChild(newPanel, panel);
      panel = null;

      // refresh the panels
      uiTrayPanels = document.querySelectorAll(".ui-tray__panel");

      // TODO? Tooltips
      window.ui.initTooltips();
      addNewTabHints(newPanel);
    } else {
      panel.classList.remove("ui-tray__panel--loading");
      panel.classList.add("ui-tray__panel--error");
    }

    updateTrayCounts();
  };

  xhr.send();
}

function updateTrayCounts() {
  var unreads = {};
  var alert = false;

  uiTrayPanels.forEach(function (panel) {
    if (panel.hasAttribute("data-unread")) {
      unreads[panel.dataset.tray] = true;
    }
    if (panel.hasAttribute("data-alert")) {
      alert = true;
    }
  });

  uiTrayTabs.forEach(function (tab) {
    if (unreads[tab.dataset.tray] === true) {
      tab.setAttribute("data-unread", "");
    } else {
      tab.removeAttribute("data-unread");
    }

    if (tab.dataset.tray === "notifications" && alert === true) {
      tab.setAttribute("data-alert", "");
    } else {
      tab.removeAttribute("data-alert");
    }
  });
}

function closeTray(skipRestore) {
  if (!isTrayOpen()) {
    return;
  }

  uiRoot.classList.remove("ui--tray-open");
  uiTrayTabs.forEach(function (tab) {
    tab.setAttribute("aria-expanded", "false");
  });
  document.removeEventListener("keydown", doTrayKeydown);
  bodyScrollLock.clearAllBodyScrollLocks();
  if (skipRestore) { discardFocus(); } else { restoreFocus(); }
}

function doTrayTabClick(evt) {
  if (a11yClick(evt)) {
    openTray(evt.currentTarget.dataset.tray);
    evt.preventDefault();
  }
}

function doTrayCloseClick(evt) {
  if (a11yClick(evt)) {
    closeTray();
    evt.preventDefault();
  }
}


window.ui.openTray = openTray;
window.ui.closeTray = closeTray;

// Make sure notifications is activated
if (uiTray) {
  uiTrayTabs.forEach(function (tab) {
    tab.addEventListener("click", doTrayTabClick);
    tab.addEventListener("keydown", doTrayTabClick);
  });

  uiTrayPanels.forEach(function (panel) {
    loadTrayPanel(panel);
  });

  uiTrayClose.addEventListener("click", doTrayCloseClick);
  uiTrayClose.addEventListener("keydown", doTrayCloseClick);

  // Activate the first available tray, or notifications
  if (uiTrayTabs[0]) {
    activateTray(uiTrayTabs[0].dataset.tray);
  } else {
    activateTray("notifications");
  }
}

// ********************
// Search

var searchSavedQuery = "";
var searchCache = {};
var feedbackCache = {};
var pendingQuery = null;

function doSearchKeydown(evt) {
  if (escKey(evt)) {
    closeSearch();
    evt.preventDefault();
  } else if (evt.key === "ArrowDown" || evt.key === "ArrowUp") {
    moveSearchSelection(evt.key === "ArrowDown" ? 1 : -1);
    evt.preventDefault();
  } else if (uiSearch) {
    trapFocus(evt, uiSearch);
  }
}

// Arrow-key navigation through the result/suggestion items. Down from the input
// focuses the first item; Up from the first item returns to the input.
function moveSearchSelection(direction) {
  var items = Array.from(uiSearchResults.querySelectorAll(".menu__item"));
  if (items.length === 0) return;

  var current = items.indexOf(document.activeElement);
  var next = current + direction;

  if (next < 0) {
    uiSearchInput.focus();
  } else if (next < items.length) {
    items[next].focus();
  } else {
    items[items.length - 1].focus();
  }
}

function openSearch(query, scope) {
  closeNav(true);
  closeMenu(true);
  closeTray(true);
  saveFocus();

  uiRoot.classList.add("ui--search-open");
  if (uiSearchToggle) uiSearchToggle.setAttribute("aria-expanded", "true");
  uiSearchInput.value = searchSavedQuery;
  preloadAnswerData();

  bodyScrollLock.disableBodyScroll(uiSearchResults);
  document.addEventListener("keydown", doSearchKeydown);
  window.ui.initTooltips();

  requestAnimationFrame(function () {
    if (uiSearchInput) uiSearchInput.focus();
  });
}

function preloadAnswerData() {
  if (!uiSearch.classList.contains("ui-search--answers-enabled") || uiSearch.classList.contains("ui-search--answers-preloaded")) {
    return;
  }
  uiSearch.classList.add("ui-search--answers-preloaded");
  var preloadUrl = uiSearch.dataset.preloadUrl;
  var xhrRequest = new XMLHttpRequest();
  xhrRequest.open("POST", preloadUrl);
  xhrRequest.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  var csrfToken = document.querySelector("meta[name=csrf-token]");
  if (csrfToken) {
    xhrRequest.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
  }
  xhrRequest.send();
}

function closeSearch(skipRestore) {
  cancelSuggestions();
  uiRoot.classList.remove("ui--search-open");
  if (uiSearchToggle) uiSearchToggle.setAttribute("aria-expanded", "false");
  searchSavedQuery = searchQuery();
  uiSearchInput.value = "";
  bodyScrollLock.clearAllBodyScrollLocks();
  document.removeEventListener("keydown", doSearchKeydown);
  if (skipRestore) { discardFocus(); } else { restoreFocus(); }
}

function isSearchOpen() {
  return uiRoot.classList.contains("ui--search-open");
}

function isSearchQueryBlank() {
  return searchQuery() === "";
}

function searchQuery() {
  return uiSearchInput.value.replace(/\s+/g, " ").trim();
}

function searchQueryCacheKey() {
  return searchQuery() + "|" + (uiAnswerAsUserHiddenInput?.value || "");
}

function searchResultsUrl(query) {
  var url = uiSearchForm.dataset.url;

  var params = new URLSearchParams();
  params.set("query", query);
  params.set("answer_as_user", uiAnswerAsUserHiddenInput?.value);
  url = url + "?" + params.toString();

  return url;
}

function searchSuggestUrl(query) {
  var params = new URLSearchParams();
  params.set("query", query);
  return uiSearchForm.dataset.suggestUrl + "?" + params.toString();
}

var searchXHR = null;

// Autocomplete suggestions (index-only, fired as the user types). Separate from
// the Enter/full-search path so neither clobbers the other.
var suggestXHR = null;
var suggestDebounce = null;
var suggestCache = {};
var SUGGEST_DEBOUNCE_MS = 180;

function cancelSuggestions() {
  clearTimeout(suggestDebounce);
  suggestDebounce = null;
  if (suggestXHR != null) {
    suggestXHR.abort();
    suggestXHR = null;
  }
}

function showSuggestions(html, forQuery) {
  // Ignore a stale render if the query moved on or a full search started.
  if (searchQuery() !== forQuery) return;
  uiSearchResults.innerHTML = html;
  window.ui.initTooltips();
}

function loadSearchSuggestions() {
  var activeQuery = searchQuery();
  if (activeQuery === "") return;

  // Cache hit: render with no round-trip (covers retyping and backspacing).
  var cached = suggestCache[activeQuery];
  if (cached != null) {
    showSuggestions(cached, activeQuery);
    return;
  }

  if (suggestXHR != null) suggestXHR.abort();

  var xhr = new XMLHttpRequest();
  suggestXHR = xhr;
  xhr.open("GET", searchSuggestUrl(activeQuery));
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  xhr.onload = function () {
    if (xhr.status === 200) {
      suggestCache[activeQuery] = xhr.responseText;
      showSuggestions(xhr.responseText, activeQuery);
    }
    // Only clear the global if a newer request hasn't replaced us.
    if (suggestXHR === xhr) suggestXHR = null;
  };
  xhr.send();
}

function announceSearchResults() {
  var statusEl = document.querySelector(".ui-search__status");
  if (!statusEl) return;

  // Count real results by checking for result category headings
  var hasResults = uiSearchResults.querySelectorAll(".menu__heading").length > 0;
  if (hasResults) {
    // Count items that are direct children of .menu (not inside the footer .menu__group)
    var allItems = uiSearchResults.querySelectorAll(".menu > .menu__item");
    statusEl.textContent = allItems.length + " search " + (allItems.length === 1 ? "result" : "results");
  } else {
    statusEl.textContent = "No results found";
  }
}

function loadSearchResults() {
  var activeQuery = searchQuery();
  var activeQueryCacheKey = searchQueryCacheKey();

  if (searchCache[activeQueryCacheKey] != null) {
    // console.log('[HIT]  Showing results for:', activeQuery)
    uiSearchResults.innerHTML = searchCache[activeQueryCacheKey];
    uiSearch.classList.remove("ui-search--loading");
    if (feedbackCache[activeQueryCacheKey] === true) {
      uiSearch.classList.add("ui-search--feedback-completed");
    } else {
      uiSearch.classList.remove("ui-search--feedback-completed", "ui-search--feedback-no-reasons");
    }
    announceSearchResults();
  } else {
    if (pendingQuery == activeQuery) {
      return;
    }

    if (searchXHR != null) {
      searchXHR.abort();
    }

    uiSearch.classList.add("ui-search--loading");
    var resultsURL = searchResultsUrl(activeQuery);
    // console.log('[MISS] Fetching results for:', activeQuery, resultsURL)

    pendingQuery = activeQuery;

    searchXHR = new XMLHttpRequest();
    searchXHR.open("GET", resultsURL);
    searchXHR.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    searchXHR.onload = function () {
      if (searchXHR.status === 200) {
        searchCache[activeQueryCacheKey] = searchXHR.responseText;
        loadSearchResults();

        // remove from pending
        pendingQuery = null;
      }
    };

    searchXHR.send();
  }
  window.ui.initTooltips();
}

function clearSearchQuery() {
  uiSearchInput.value = "";
  searchSavedQuery = "";
  uiSearchInput.focus();
  loadSearchResults();
  uiSearch.classList.remove("ui-search--query");
}

function doSearchBackClick(evt) {
  if (a11yClick(evt)) {
    closeSearch();
    evt.preventDefault();
  }
}

function doSearchClearClick(evt) {
  if (a11yClick(evt)) {
    clearSearchQuery();
    evt.preventDefault();
  }
}

function doSearchInputClick(evt) {
  // When search is already open, clicking the input must not re-run openSearch:
  // it would overwrite the in-progress value with the stale searchSavedQuery.
  // Let the click fall through so the browser places the caret normally.
  if (isSearchOpen()) return;

  if (a11yClick(evt)) {
    openSearch(null, null);
    evt.preventDefault();
  }
}

function doSearchInputKeypress(evt) {
  if (evt.key == "Enter") {
    evt.preventDefault();
    updateSearch();
  }

  if (!isSearchOpen() && a11yClick(evt) && isSearchQueryBlank()) {
    openSearch(null, null);
    evt.preventDefault();
  }
}

function doSearchSubmitClick(evt) {
  if (a11yClick(evt)) {
    updateSearch();
    evt.preventDefault();
  }
}

function updateSearch() {
  searchSavedQuery = searchQuery();

  // Enter/submit runs the full search (AI + my3); drop any pending suggestion
  // request so a late response can't overwrite the full results.
  cancelSuggestions();
  uiSearch.classList.toggle("ui-search--query", !isSearchQueryBlank());
  loadSearchResults();
}

function doSearchInputInput(evt) {
  if (isSearchQueryBlank()) {
    uiSearch.classList.remove("ui-search--query");
    cancelSuggestions();
    loadSearchResults(); // restore the default (empty-query) menu
    return;
  }

  uiSearch.classList.add("ui-search--query");

  // Cache hit renders immediately (no debounce, no round-trip); otherwise
  // debounce the network request as the user keeps typing.
  if (suggestCache[searchQuery()] != null) {
    cancelSuggestions();
    loadSearchSuggestions();
    return;
  }

  clearTimeout(suggestDebounce);
  suggestDebounce = setTimeout(loadSearchSuggestions, SUGGEST_DEBOUNCE_MS);
}

function doFeedbackLinkClick(evt) {
  var evtTargetFeedbackLink = evt.target.closest(".answer-feedback__link--rate");
  if (evtTargetFeedbackLink) {
    if (evtTargetFeedbackLink.classList.contains("answer-feedback__link--clicked")) {
      return;
    }
    if (uiSearch.classList.contains("ui-search--loading")) {
      return;
    }
    evt.preventDefault();
    evtTargetFeedbackLink.classList.add("answer-feedback__link--clicked");
    var feedbackUrl = evtTargetFeedbackLink.dataset.url;
    if (!feedbackUrl) {
      return;
    }
    var feedbackShowNoReasons = evtTargetFeedbackLink.dataset.showNoReasons !== undefined;

    var feedbackXHR = new XMLHttpRequest();
    feedbackXHR.open("POST", feedbackUrl);
    feedbackXHR.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    var csrfToken = document.querySelector("meta[name=csrf-token]");
    if (csrfToken) {
      feedbackXHR.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
    }

    feedbackXHR.onload = function () {
      if (feedbackXHR.status === 200) {
        uiSearch.classList.remove("ui-search--feedback-no-reasons");

        if (feedbackShowNoReasons === true) {
          uiSearch.classList.add("ui-search--feedback-no-reasons");
        } else {
          uiSearch.classList.add("ui-search--feedback-completed");
        }
        feedbackCache[searchQueryCacheKey()] = true;
      }
    };

    feedbackXHR.send();
  }
}

function doFeaturePreferenceClick(evt) {
  if (uiSearch.classList.contains("ui-search--loading")) {
    return;
  }
  var evtTargetPreferenceLink = evt.target.closest(".search-answer-preference-button");
  var evtTargetPreferenceToggle = evt.target.closest(".toggle-switch") || (evt.target.classList.contains("search-answer-preference-checkbox") ? evt.target.closest(".search-answer-preference-label").querySelector(".toggle-switch") : null);
  if (evtTargetPreferenceLink) {
    var preferenceUrl = evtTargetPreferenceLink.dataset.url;
    if (!preferenceUrl) {
      return;
    }
    var xhrRequest = new XMLHttpRequest();
    xhrRequest.open("POST", preferenceUrl);
    xhrRequest.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    var csrfToken = document.querySelector("meta[name=csrf-token]");
    if (csrfToken) {
      xhrRequest.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
    }

    xhrRequest.onload = function () {
      if (xhrRequest.status === 200) {
        uiSearch.classList.add("ui-search--answer-preference-saved");
        window.location.reload();
      }
    }
    xhrRequest.send();
  } else if (evtTargetPreferenceToggle) {
    if (evtTargetPreferenceToggle.classList.contains("toggle-switch--processing")) {
      return;
    }
    evtTargetPreferenceToggle.classList.add("toggle-switch--processing");
    var settingsDiv = evtTargetPreferenceToggle.closest('.search-answer-setting')
    if (settingsDiv) {
      var currentlyEnabled = settingsDiv.classList.contains("search-answer-preference--on");
      var form = settingsDiv.querySelector('#search-answer-preference-form');
      var xhrRequest = new XMLHttpRequest();
      xhrRequest.open(form.method, form.action);
      xhrRequest.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      xhrRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      var csrfToken = document.querySelector("meta[name=csrf-token]");
      if (csrfToken) {
        xhrRequest.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
      }
      xhrRequest.onload = function () {
        if (xhrRequest.status === 200) {
          settingsDiv.classList.toggle("search-answer-preference--on");
          evtTargetPreferenceToggle.classList.remove("toggle-switch--processing");
          if (uiSearch.classList.contains("ui-search--query")) {
            searchCache = {}; // Clear the search cache to allow the same search term to be reloaded
            updateSearch();
          }
        }
      }

      xhrRequest.send('opt_in=' + (currentlyEnabled ? '0' : '1'));
    }
  }
}

function trackStandaloneMode() {
  if (window.navigator.standalone) {
    var xhrRequest = new XMLHttpRequest();
    xhrRequest.open("POST", "/_ui/standalone");
    xhrRequest.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    var csrfToken = document.querySelector("meta[name=csrf-token]");
    if (csrfToken) {
      xhrRequest.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
    }
    xhrRequest.send();
  }
}

trackStandaloneMode();

if (uiSearch) {
  loadSearchResults();

  uiSearchResults.addEventListener("click", doFeedbackLinkClick);
  uiSearchResults.addEventListener("click", doFeaturePreferenceClick);
  uiSearchResults.addEventListener("change", doFeaturePreferenceClick);

  uiSearchBack.addEventListener("click", doSearchBackClick);
  uiSearchBack.addEventListener("keydown", doSearchBackClick);

  uiSearchInput.addEventListener("click", doSearchInputClick);
  uiSearchInput.addEventListener("keydown", doSearchInputKeypress);

  uiSearchToggle.addEventListener("click", doSearchInputClick);
  uiSearchToggle.addEventListener("keydown", doSearchInputClick);

  uiSearchClear.addEventListener("click", doSearchClearClick);
  uiSearchClear.addEventListener("keydown", doSearchClearClick);

  uiSearchSubmit.addEventListener("click", doSearchSubmitClick);
  uiSearchSubmit.addEventListener("keydown", doSearchSubmitClick);

  uiSearchInput.addEventListener("input", doSearchInputInput);

  uiSearch.addEventListener("change", function(evt) {
    if (evt.target.id === "select_answer_as_user") {
      uiAnswerAsUserHiddenInput.value = evt.target.value;
    }
  });
}

// ********************
// External links: add screen reader hint for target="_blank" links (SSO services where back-button breaks)
function addNewTabHints(container) {
  (container || document).querySelectorAll('a[target="_blank"]:not([data-new-tab-hint])').forEach(function (link) {
    var hint = document.createElement("span");
    hint.textContent = " (opens in new tab)";
    hint.className = "sr-only";
    link.appendChild(hint);
    link.setAttribute("data-new-tab-hint", "");
  });
}

addNewTabHints();
window.ui.addNewTabHints = addNewTabHints;

window.ui.openSearch = openSearch;
